// frontend/src/askos/askosApi.js
//
// Thin shared helper for the new dashboard's authenticated calls, mirroring
// the askosAuthHeader() convention already used throughout pages/AskOS.js
// (explicit Authorization header per call, built from the askos_token key).
import api from '../api/api';

export const askosAuthHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('askos_token')}` });

export default api;
